(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@angular/cdk/platform'), require('rxjs'), require('rxjs/operators'), require('@material/tab-scroller')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/mdc-test-web/tab-scroller', ['exports', '@angular/core', '@angular/cdk/platform', 'rxjs', 'rxjs/operators', '@material/tab-scroller'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.mdcTestWeb = global.shraddhar.mdcTestWeb || {}, global.shraddhar.mdcTestWeb.tabScroller = {}), global.ng.core, global.ng.cdk.platform, global.rxjs, global.rxjs.operators, global.mdc.tabScroller));
}(this, (function (exports, core, platform, rxjs, operators, tabScroller) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __exportStar(m, exports) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }

    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }

    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    }

    function __asyncDelegator(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    }

    function __asyncValues(o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    }

    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    function __importStar(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result.default = mod;
        return result;
    }

    function __importDefault(mod) {
        return (mod && mod.__esModule) ? mod : { default: mod };
    }

    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    }

    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    }

    var MDCComponent = /** @class */ (function () {
        function MDCComponent(elementRef, foundation) {
            var args = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args[_i - 2] = arguments[_i];
            }
            this._elementRef = elementRef;
            this.initialize.apply(this, __spread(args));
            // Note that we initialize foundation here and not within the constructor's default param.
            this._foundation = foundation === undefined ? this.getDefaultFoundation() : foundation;
        }
        /* istanbul ignore next: method param only exists for typing purposes; it does not need to be unit tested */
        MDCComponent.prototype.initialize = function () {
            var _args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                _args[_i] = arguments[_i];
            }
            // Subclasses can override this to do any additional setup work that would be considered part of a
            // "constructor". Essentially, it is a hook into the parent constructor before the foundation is
            // initialized. Any additional arguments besides root and foundation will be passed in here.
        };
        MDCComponent.prototype.getDefaultFoundation = function () {
            // Subclasses must override this method to return a properly configured foundation class for the
            // component.
            throw new Error('Subclasses must override getDefaultFoundation to return a properly configured ' +
                'foundation class');
        };
        MDCComponent.prototype.destroy = function () {
            var _a;
            // Subclasses may implement this method to release any resources / deregister any listeners they have
            // attached. An example of this might be deregistering a resize event from the window object.
            (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.destroy();
        };
        return MDCComponent;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var hasNativeClosest = typeof Element !== 'undefined' && !!Element.prototype.closest;
    /** IE 11 compatible closest implementation that is able to start from non-Element Nodes. */
    function closest(element, selector) {
        if (!(element instanceof Node)) {
            return null;
        }
        var curr = element;
        while (curr != null && !(curr instanceof Element)) {
            curr = curr.parentNode;
        }
        return curr && (hasNativeClosest ?
            curr.closest(selector) : polyfillClosest(curr, selector));
    }
    /** Polyfill for browsers without Element.closest. */
    function polyfillClosest(element, selector) {
        var curr = element;
        while (curr != null && !(curr instanceof Element && matches(curr, selector))) {
            curr = curr.parentNode;
        }
        return (curr || null);
    }
    /** IE 11 compatible matches implementation. */
    function matches(element, selector) {
        return element.matches ?
            element.matches(selector) :
            element['msMatchesSelector'](selector);
    }

    /**
     * Generated bundle index. Do not edit.
     */

    var SCROLLER_EVENTS = [
        'keydown',
        'mousedown',
        'pointerdown',
        'touchstart',
        'wheel'
    ];
    var MdcTabScroller = /** @class */ (function (_super) {
        __extends(MdcTabScroller, _super);
        function MdcTabScroller(_ngZone, _platform, elementRef) {
            var _this = _super.call(this, elementRef) || this;
            _this._ngZone = _ngZone;
            _this._platform = _platform;
            _this.elementRef = elementRef;
            /** Emits whenever the component is destroyed. */
            _this._destroy = new rxjs.Subject();
            _this._align = null;
            _this._scrollAreaEventsSubscription = null;
            return _this;
        }
        Object.defineProperty(MdcTabScroller.prototype, "align", {
            get: function () {
                return this._align;
            },
            set: function (value) {
                this.setAlign(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTabScroller.prototype, "scrollAreaEvents", {
            /** Combined stream of all of the scroll area events. */
            get: function () {
                var _this = this;
                return rxjs.merge.apply(void 0, __spread(SCROLLER_EVENTS.map(function (evt) {
                    return rxjs.fromEvent(_this._getScrollArea(), evt, { passive: platform.supportsPassiveEventListeners() });
                })));
            },
            enumerable: true,
            configurable: true
        });
        MdcTabScroller.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                eventTargetMatchesSelector: function (evtTarget, selector) { return matches(evtTarget, selector); },
                addClass: function (className) { return _this._getHostElement().classList.add(className); },
                removeClass: function (className) { return _this._getHostElement().classList.remove(className); },
                addScrollAreaClass: function (className) { return _this.area.nativeElement.classList.add(className); },
                setScrollAreaStyleProperty: function (propName, value) {
                    return _this.area.nativeElement.style.setProperty(propName, value);
                },
                setScrollContentStyleProperty: function (propName, value) {
                    return _this.content.nativeElement.style.setProperty(propName, value);
                },
                getScrollContentStyleValue: function (propName) {
                    return _this._platform.isBrowser ? window.getComputedStyle(_this.content.nativeElement).getPropertyValue(propName) : '';
                },
                setScrollAreaScrollLeft: function (scrollX) { return _this.area.nativeElement.scrollLeft = scrollX; },
                getScrollAreaScrollLeft: function () { return _this.area.nativeElement.scrollLeft; },
                getScrollContentOffsetWidth: function () { return _this.content.nativeElement.offsetWidth; },
                getScrollAreaOffsetWidth: function () { return _this.area.nativeElement.offsetWidth; },
                computeScrollAreaClientRect: function () {
                    return _this._platform.isBrowser ? _this.area.nativeElement.getBoundingClientRect() : {};
                },
                computeScrollContentClientRect: function () {
                    return _this._platform.isBrowser ? _this.content.nativeElement.getBoundingClientRect() : {};
                },
                computeHorizontalScrollbarHeight: function () {
                    return _this._platform.isBrowser ? tabScroller.util.computeHorizontalScrollbarHeight(document) : 0;
                }
            };
            return new tabScroller.MDCTabScrollerFoundation(adapter);
        };
        MdcTabScroller.prototype.ngAfterViewInit = function () {
            this._foundation.init();
            this._loadListeners();
        };
        MdcTabScroller.prototype.ngOnDestroy = function () {
            this._destroy.next();
            this._destroy.complete();
            if (this._scrollAreaEventsSubscription) {
                this._scrollAreaEventsSubscription.unsubscribe();
            }
        };
        MdcTabScroller.prototype.setAlign = function (align) {
            this._getHostElement().classList.remove("mdc-tab-scroller--align-" + this._align);
            this._align = align;
            if (align) {
                this._getHostElement().classList.add("mdc-tab-scroller--align-" + align);
            }
        };
        /** Returns the current visual scroll position */
        MdcTabScroller.prototype.getScrollPosition = function () {
            if (!this._platform.isBrowser) {
                return -1;
            }
            return this._foundation.getScrollPosition();
        };
        /** Returns the width of the scroll content */
        MdcTabScroller.prototype.getScrollContentWidth = function () {
            return this.content.nativeElement.offsetWidth;
        };
        /** Increments the scroll value by the given amount */
        MdcTabScroller.prototype.incrementScroll = function (scrollXIncrement) {
            if (!this._platform.isBrowser) {
                return;
            }
            this._foundation.incrementScroll(scrollXIncrement);
        };
        /** Scrolls to the given pixel position */
        MdcTabScroller.prototype.scrollTo = function (scrollX) {
            this._foundation.scrollTo(scrollX);
        };
        MdcTabScroller.prototype._loadListeners = function () {
            var _this = this;
            this._scrollAreaEventsSubscription = this.scrollAreaEvents.pipe()
                .subscribe(function () { return _this._foundation.handleInteraction(); });
            this._ngZone.runOutsideAngular(function () {
                return rxjs.fromEvent(_this._getScrollContent(), 'transitionend')
                    .pipe(operators.takeUntil(_this._destroy), operators.filter(function (e) {
                    return e.target === _this._getScrollContent();
                }))
                    .subscribe(function (evt) { return _this._ngZone.run(function () { return _this._foundation.handleTransitionEnd(evt); }); });
            });
        };
        MdcTabScroller.prototype._getScrollArea = function () {
            return this.area.nativeElement;
        };
        MdcTabScroller.prototype._getScrollContent = function () {
            return this.content.nativeElement;
        };
        /** Retrieves the DOM element of the component host. */
        MdcTabScroller.prototype._getHostElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcTabScroller.decorators = [
            { type: core.Component, args: [{
                        selector: '[mdcTabScroller], mdc-tab-scroller',
                        exportAs: 'mdcTabScroller',
                        host: {
                            'class': 'mdc-tab-scroller'
                        },
                        template: "<div #area class=\"mdc-tab-scroller__scroll-area\">\r\n  <div #content class=\"mdc-tab-scroller__scroll-content\">\r\n    <ng-content></ng-content>\r\n  </div>\r\n</div>",
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None
                    }] }
        ];
        /** @nocollapse */
        MdcTabScroller.ctorParameters = function () { return [
            { type: core.NgZone },
            { type: platform.Platform },
            { type: core.ElementRef }
        ]; };
        MdcTabScroller.propDecorators = {
            align: [{ type: core.Input }],
            area: [{ type: core.ViewChild, args: ['area', { static: true },] }],
            content: [{ type: core.ViewChild, args: ['content', { static: true },] }]
        };
        return MdcTabScroller;
    }(MDCComponent));

    var MdcTabScrollerModule = /** @class */ (function () {
        function MdcTabScrollerModule() {
        }
        MdcTabScrollerModule.decorators = [
            { type: core.NgModule, args: [{
                        exports: [MdcTabScroller],
                        declarations: [MdcTabScroller]
                    },] }
        ];
        return MdcTabScrollerModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MdcTabScroller = MdcTabScroller;
    exports.MdcTabScrollerModule = MdcTabScrollerModule;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-tab-scroller.umd.js.map
